import { render, staticRenderFns } from "./EntityCustomFields.vue?vue&type=template&id=3cbacf8a"
import script from "./EntityCustomFields.vue?vue&type=script&lang=js"
export * from "./EntityCustomFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports